import reportApi from '~/clientApis/reportApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { ReportEmailParams } from '~/definitions/report';
import { getStore } from '~/mobx/AppStore';

const sendReportEmail = async () => {
    const { reportStore, electionMenuStore, regionStore, generalSettingsStore } = getStore();

    if (!reportStore.email) {
        return;
    }

    const reportType: ReportEmailParams['reportType'] = electionMenuStore.isCompanyLevel
        ? 'company'
        : reportStore.isShowedUserVoteList
          ? 'stand'
          : 'region';

    // Prepare additional params based on reportType
    let additionalParams: Partial<ReportEmailParams> = {};
    const regionId = regionStore.selectedRegionId;

    if (reportType === 'region') {
        additionalParams = { regionId };
    } else if (reportType === 'stand') {
        additionalParams = {
            regionId,
            year: generalSettingsStore.getSelectedElectionYear(),
        };
    }

    const params: ReportEmailParams = {
        email: reportStore.email,
        reportType,
        ...additionalParams,
    };

    reportStore.setIsSendingReportFile(true);

    try {
        await reportApi.sendReportEmail(params);
    } catch (error) {
        const errorMessage = (await (error as Response).json()).error;
        showMessageModal('error', errorMessage);
    } finally {
        reportStore.setIsSendingReportFile(false);
        reportStore.setEmail('');
    }
};

export default sendReportEmail;
